import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPut, operationsClient } from '@/lib/api';
import { leadRepAvailabilityEndpoints } from '@/lib/api/endpoints';
import { leadRepAvailabilityKeys } from '@/lib/queryKeys';
import type { LeadRepAvailability, LeadRepUnavailableReason } from './useLeadRepAvailability';

export interface UpdateLeadRepAvailabilityDto {
  isAvailable: boolean;
  unavailableReason?: LeadRepUnavailableReason;
  unavailableUntil?: string;
}

export function useUpdateLeadRepAvailability() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadRepAvailability, { userId: string } & UpdateLeadRepAvailabilityDto>({
    mutationFn: ({ userId, ...dto }) =>
      apiPut<LeadRepAvailability, UpdateLeadRepAvailabilityDto>(
        operationsClient,
        leadRepAvailabilityEndpoints.update(userId),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadRepAvailabilityKeys.list() });
      toast.success('Rep availability updated');
    },
  });
}
